module.exports = __webpack_public_path__ + "img/img-f9755d.png";